import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/product";

const REVEAL = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};
const reveal = (delay = 0) => ({ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] });
const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const CategoryCard = ({ image, imageAlt, title, copy, cta, target, delay, testId }) => (
  <motion.div
    {...REVEAL}
    transition={reveal(delay)}
    className="relative rounded-2xl overflow-hidden group min-h-[380px] flex items-end"
    data-testid={testId}
  >
    <img
      src={image}
      alt={imageAlt}
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#241813]/85 via-[#241813]/30 to-transparent" aria-hidden />
    <div className="relative z-10 p-8 sm:p-10">
      <h3 className="font-serif-display font-medium text-3xl text-white" data-testid={`${testId}-title`}>{title}</h3>
      <p className="mt-3 text-sm font-light leading-relaxed text-[#EDE3D6] max-w-sm">{copy}</p>
      <button
        type="button"
        onClick={() => scrollTo(target)}
        className="mt-6 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#F8F4EC] text-[#3A2A25] text-xs font-semibold uppercase tracking-[0.2em] hover:bg-white hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
        data-testid={`${testId}-cta`}
      >
        {cta}
        <ArrowRight size={14} strokeWidth={2} />
      </button>
    </div>
  </motion.div>
);

export const ShopByCategory = () => (
  <section className="bg-[#FFFDF9] border-y border-[rgba(58,42,37,0.08)]" data-testid="category-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28">
      <motion.div {...REVEAL} transition={reveal(0)}>
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">Shop by Category</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] leading-tight" data-testid="category-heading">
          Care for <span className="italic text-[#3A2A25]">every routine.</span>
        </h2>
      </motion.div>
      <div className="mt-12 grid md:grid-cols-2 gap-6 lg:gap-10">
        <CategoryCard
          image={IMAGES.whyLifestyle}
          imageAlt="CELUSTA Hair Care"
          title="Hair Care"
          copy="Simple care for softer, smoother, more manageable hair."
          cta="Shop Hair"
          target="shop"
          delay={0.1}
          testId="category-card-hair"
        />
        <CategoryCard
          image="/images/hero-beauty.webp"
          imageAlt="CELUSTA Body Care"
          title="Body Care"
          copy="Elevated everyday care designed for your body routine."
          cta="Explore Body Care"
          target="body-care"
          delay={0.2}
          testId="category-card-body"
        />
      </div>
    </div>
  </section>
);
